import { Box, Typography, Button } from "@mui/material";
import { UserDocument } from "../../models/UserDocument";
import { Modes } from "./types";
import { imageUrls } from "../../constants/imageUrls";
import { documentsAPI } from "apis";
import { useState } from "react";


export interface UserDocumentModesProps {
  document: UserDocument;
  documentSrc: string;
  currentMode: Modes;
  setMode: (mode: Modes) => void;
  documentId?: string | number
  onComplete?: (shouldClose: boolean) => void;
  onCancel?: () => void;
  onUpdateDoc?: () => void;
}

export const DeleteUserDocument = ({
  document,
  onCancel,
  onComplete,
  documentId,
}: UserDocumentModesProps): JSX.Element => {
  const [errors, setErrors] = useState<string>("")

  const handleDelete = async () => {
    if (!documentId) {
      return
    }
    if (isNaN(parseInt(documentId.toString()))) {
      return
    }

    try {
      const deleted = await documentsAPI.deleteDocument(parseInt(documentId.toString()))
      if (!deleted) {
        setErrors("unable to delete file, please try again or contact support@weareatticus.biz")
        return
      }
    } catch (e) {
      setErrors((e as any).message)
      return
    }

    onComplete?.(true);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: 100,
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          textAlign: "center",
          maxWidth: 500,
          mx: "auto",
        }}
      >
        <Box
          sx={{
            my: 2,
          }}
        >
          <img
            srcSet={`${imageUrls["trashcan@2x"]} 2x, ${imageUrls["trashcan@3x"]} 3x`}
            src={imageUrls["trashcan@1x"]}
            alt="Trash can"
          />
        </Box>
        <Typography variant="h4">
          Are you sure you want to delete "{document?.version?.title}"?
        </Typography>
        <Typography>You won't be able to undo this action.</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          alignItems: "center",
          "& button": {
            my: 1,
          },
          mt: 2,
        }}
      >
        <Button variant="text" onClick={() => onCancel?.()}>
          Cancel
        </Button>
        <Button variant="contained" onClick={() => handleDelete?.()}>
          Delete
        </Button>
      </Box>
      {errors && <Typography color="error" variant="body1">
        {errors}
      </Typography>}
    </Box>
  );
};